export default __webpack_public_path__ + "static/B0197-71d104231fc7b586d241024fe6f4e34b.png";